import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const Icon = styled.img`
  width: 24px;
`;

export const Text = styled.p`
  font-size: 16px;
`;
